// 'anonymous' is a special security identity that signifies a non-authenticated user:
// https://docs.coveo.com/en/56/build-a-search-ui/use-search-token-authentication#name-string-required
export enum SecurityUser {
  external = 'anonymous',
  internal = '*@unity3d.com',
}

export enum SearchHub {
  external = 'docs.unity.com-search',
  internal = 'internal.docs.unity.com-search',
}
